// src/app.config.ts
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { appRoutes } from './app.routes';

import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';

// Custom interceptors
import { staticAuthTokenInterceptor } from './app/core/shared/static-auth-token-interceptor';

// MSAL
import { InteractionType } from '@azure/msal-browser';
import { MsalModule, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { msalInstance, protectedResourceMap, apiScopes } from './app/pages/auth/msal.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withEnabledBlockingInitialNavigation()
    ),

    importProvidersFrom(
      MsalModule.forRoot(
        msalInstance,
        {
          interactionType: InteractionType.Redirect,
          authRequest: {
            scopes: ['openid', 'profile', 'offline_access', ...apiScopes],
          },
        },
        {
          interactionType: InteractionType.Redirect,
          protectedResourceMap,
        }
      )
    ),

    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },

    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([staticAuthTokenInterceptor])
    ),

    // Removed APP_INITIALIZER and T0InitializerService
    // Baseline will be loaded only when navigating to /t0-dashboard (via TierAccessGuard kickoff)

    MsalGuard,

    providePrimeNG({
      theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } },
    }),
  ],
};